'use client'

import {serverCall} from "@/redux/apis/http";
import {RENEW_PASSWORD, RESET_PASSWORD, USER_REGISTRATION} from "@/components/admin/login/types";
import {GENERAL_OBJECT} from "@/components/types";

export const processUserLogin = async (data: GENERAL_OBJECT) => {
    return await serverCall({
        type: "post",
        data: {
            ...data,
            customQueryFile: "login",
        },
        timeout: 1,
        endpoint: "/processLogin",
        apiDir: `webapi/shared`,
    }, null);
}

export const resendActivationCode = async (data: any) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data,
            customQueryFile: "login",
        },
        endpoint: "/resendActivationCode",
        apiDir: `webapi/shared`,
    }, null);
}

export const getActivationTime = async () => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            customQueryFile: "login",
        },
        endpoint: "/getActivationTime",
        apiDir: `webapi/shared`,
    }, null);
}

export const verifyActivationCode = async (activationCode: number) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            activationCode,
            customQueryFile: "login",
        },
        endpoint: "/verifyActivationCode",
        apiDir: `webapi/shared`,
    }, null);
}

export const resetPassword = async (data: RESET_PASSWORD) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data,
            customQueryFile: "login",
        },
        endpoint: "/resetPassword",
        apiDir: `webapi/shared`,
    }, null);
}

export const renewPassword = async (data: RENEW_PASSWORD) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data,
            customQueryFile: "login",
        },
        endpoint: "/renewPassword",
        apiDir: `webapi/shared`,
    }, null);
}

export const processUserRegistration = async (data: USER_REGISTRATION) => {
    return await serverCall({
        type: "post",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/processUserRegistration",
        apiDir: `webapi/shared`,
    }, null);
}

export const authenticateSession = async (data: GENERAL_OBJECT) => {
    return await serverCall({
        type: "get",
        data: {
            ...data,
            noQuery: 1,
            customQueryFile: "login",
            fetchType: "noLazy"
        },
        timeout: 1,
        endpoint: "/authenticateSession",
        apiDir: `webapi/shared`,
    }, null);
}

export const getSiteImages = async () => {
    return await serverCall({
        type: "get",
        data: {
            noQuery: 1,
            customQueryFile: "userDashboard",
            fetchType: "noLazy"
        },
        timeout: 1,
        endpoint: "/getSiteImages",
        apiDir: `webapi/shared`,
    }, null);
}